import styled from "styled-components"
import Leotete from "../../assets/images/profil-picture.png"
import Ellipse from "../../assets/images/Ellipse.png"
import Ellipse1 from "../../assets/images/Ellipse1.png"

import {
    TextWrapperAccueilSection,
    AccueilSectionWrapper
} from "./AccueilElements.tsx"


const ContentWrapperAccueilSectionPresentation = styled.div`
    display: flex;
    justify-content: space-between;

    @media (max-width: 768px) {
        flex-direction: column;
    }
`

const TextAccueilSection = styled.p`
    font-family: "Inter", sans-serif;
    font-size: 24px;
    margin: 0;
    line-height: 1.5;
    margin-bottom: 2vw;
`

const ImgWrapper = styled.div`
    width: 45%;
    margin-top: 2vw;
    max-height: 35vw;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 768px) {
        min-height: 25vw;
        margin-right: auto;
        margin-left: auto;
    }
`

const ImgLeo = styled.img`
    width: 25vw;
    height: 25vw;
    position: absolute;
`

const ImgLeoPicture = styled.img`
    width: 37vw;
    height: 37vw;
    position: absolute;
`



function AccueilPresentationSection() {
    return (
        <AccueilSectionWrapper>
            <ContentWrapperAccueilSectionPresentation>
                <TextWrapperAccueilSection>
                    <TextAccueilSection>
                        En tant que <strong>développeur web freelance</strong>,
                        je vous accompagne dans la création de votre identité
                        d'entreprise.
                    </TextAccueilSection>
                    <TextAccueilSection>
                        Je m'appelle Léo Langlois et je suis capable
                        de réaliser une large gamme de projets, de la
                        <strong> conception de logos</strong> et autres designs
                        graphiques à la création complète de votre
                        <strong> site web</strong>.
                    </TextAccueilSection>
                    <TextAccueilSection>
                        J’ai déjà conçu des <strong>logos</strong> pour des entreprises,
                        des <strong>cartes de visite</strong>, ainsi que 
                        des <strong>sites web</strong> pour des étudiants, notamment 
                        des portfolios sur mesure.
                    </TextAccueilSection>
                </TextWrapperAccueilSection>
                <ImgWrapper>
                    <ImgLeo src={Ellipse} alt="Photo profil Léo" />
                    <ImgLeoPicture src={Leotete} alt="Photo profil Léo" />
                    <ImgLeo src={Ellipse1} alt="Photo profil Léo" />
                </ImgWrapper>
            </ContentWrapperAccueilSectionPresentation>
        </AccueilSectionWrapper>
    )
}

export default AccueilPresentationSection
